
/**
 * Removes the escaping backslash that only belongs in JS source (`\${token}`), so templates are never
 * persisted as `\${token}` — the stray backslash would otherwise survive server-side substitution
 * and show up in the sent email. Non-string values pass through untouched.
 */
export const stripTokenEscapes = <T>(value: T): T =>
    typeof value === 'string' ? (value.replace(/\\(?=\$?\{[a-zA-Z0-9_]+\})/g, '') as unknown as T) : value;

const generatePreviewHtml = ({ formik, defaultAdvanceReminderEmail, setting } : any) => {
    const html = formik?.values?.emailContent ?? defaultAdvanceReminderEmail?.email_body ?? '';

    const baseUrl = process.env.REACT_APP_IMG_URL || '';
    const fullImageUrl = setting?.profile_image ? baseUrl + setting.profile_image : '';

    // Stored templates copied out of a JS template literal keep the escaping backslash (\${store_logo}),
    // and some use the {store_logo} form, so consume the optional leading \ and $ along with the token.
    let modifiedHtml = html.replace(/\\?\$?\{store_logo\}/g, fullImageUrl);
    return modifiedHtml;
};

export default generatePreviewHtml;